import ProductSliderLoader from '@frontend/features/products/product-slider/ProductSliderLoader'
import { usePostBySlug } from '@frontend/libs/hooks/usePost'
import { parseHtml } from '@frontend/libs/utils'
import { Skeleton } from '@nextui-org/react'
import ErrorBoundary from '@shared/ErrorBoundary'
import { useErrorBoundary } from 'react-error-boundary'
import toast from 'react-hot-toast'

function Loader() {
  return (
    <div className="space-y-10">
      <Skeleton className="alignfull">
        <div className="aspect-[4/5] h-full w-full bg-default-300 md:aspect-[2/1]"></div>
      </Skeleton>
      <ProductSliderLoader />
      <Skeleton className="alignfull">
        <div className="aspect-[4/5] h-full w-full bg-default-300 md:aspect-[2/1]"></div>
      </Skeleton>
      <ProductSliderLoader />
    </div>
  )
}

function Content() {
  const { showBoundary } = useErrorBoundary()
  const { data: post, error, isLoading } = usePostBySlug('home')

  if (isLoading) return <Loader />

  if (error) {
    toast.error(error?.message || 'Failed to fetch home page')
    showBoundary(error)
  }

  if (!post) {
    showBoundary('No response data')
    return <></>
  }

  document.title = post.meta.title

  const styleTag = document.getElementById('core-block-supports-inline-css')

  if (styleTag) {
    styleTag.innerHTML = post.styles
  } else {
    const style = document.createElement('style')
    style.id = 'core-block-supports-inline-css'
    document.head.appendChild(style)
    style.innerHTML = post.styles
  }

  return parseHtml(post.content)
}

export function Home() {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default Home
